import React, { useEffect, useState } from "react";
import { AccordionDetails, AccordionSummary, Grid } from "@material-ui/core";
import { ExpandMore } from "@material-ui/icons";
import MuiIconButton from "Components/MuiIconButton/MuiIconButton";
import AlertDialog from "Components/AlertDialog/AlertDialog";
import Translator from "Languages/Utility/Translator";
import Accordion from "@material-ui/core/Accordion";
import { read } from "Helpers/LocalStorage";
import {
  AddColor,
  deleteTypeProfile,
  getAllTypeAndColor,
} from "Stores/actions";
import { useDispatch, useSelector } from "react-redux";
import MuiButton from "Components/MuiButton/MuiButton";
import { useSetState } from "Helpers/Hooks";
import ColorTable from "./ColorTable";
import TagFormatter from "Components/TagFormatter/TagFormatter";
import * as R from "ramda";
import Input from "Components/Input/Input";
import MuiColorAutoComplete from "Components/MuiColorAutoComplete/MuiColorAutoComplete";
import * as Icons from "react-bootstrap-icons";
import { useTranslation } from "react-i18next";

function ExpandType({ row, colorData, expanded, onChange }) {
  const { t } = useTranslation();
  const { dataRelationType } = useSelector((state) => ({
    dataRelationType: state.profile.dataRelationType,
  }));
  const [showAlert, setShowAlert] = useState(false);
  const [deleteRelationData, setDeleteRelationData] = useState(null);
  const dispatch = useDispatch();
  const [checkValid, setCheckValid] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formValid, setFormValid] = useState({
    color: false,
    nameColor: false,
  });
  const [controls, setControls] = useSetState({
    nameColor: {
      type: "text",
      value: "",
      validation: {
        required: true,
      },
    },
    color: {
      type: "select",
      selectItems: [],
      value: "",
      validation: {
        required: true,
      },
    },
  });

  const setValue = (name, value, validation) => {
    setControls({ [name]: { value: value } });
    setFormValid((prev) => ({ ...prev, [name]: validation }));
  };
  const onShowAlert = () => {
    setShowAlert(!showAlert);
    setDeleteRelationData(null);
  };
  const onDelete = async () => {
    try {
      setLoading(true);
      const data = {
        KeyGroup: read("groupKey"),
        KeyUser: read("userKey"),
        Id: row.Id,
      };
      const res = await dispatch(deleteTypeProfile(data));
      if (res) {
        onShowAlert();
      }
      setLoading(false);
      setLoading(false);
    } catch (err) {
      console.error('[catch error]', err)
    }
  };

  const onAddColor = async () => {
    const { nameColor, color } = controls;
    if (
      !R.isEmpty(formValid) &&
      Object.values(formValid).every((item) => item === true)
    ) {
      try {
        setLoading(true);
        const data = {
          KeyGroup: read("groupKey"),
          KeyUser: read("userKey"),
          Name: nameColor.value,
          IdTypeColor: row.Id,
          ColorPattern: color.value.value,
        };
        await dispatch(AddColor(data));
        const params = { KeyGroup: read("groupKey"), KeyUser: read("userKey") };
        await dispatch(getAllTypeAndColor(params));
        onClear();
        setLoading(false);
      } catch (e) {
        setLoading(false);
      }
    } else {
      setCheckValid(true);
    }
  };
  const autoCompleteColorHandler = async (e, value, controlName) => {
    setControls({ [controlName]: { value: value } });
    setFormValid((prev) => ({ ...prev, [controlName]: true }));
  };

  const onClear = () => {
    setFormValid({ nameColor: false });
    setControls({ nameColor: { value: "" } });
    setCheckValid(false);
  };

  useEffect(() => {
    if (colorData) {
      setControls({ color: { selectItems: colorData } });
    }
  }, [colorData]);

  useEffect(() => {
    setDeleteRelationData(dataRelationType);
  }, [dataRelationType]);

  return (
    <Accordion
      variant="outlined"
      disabled={row.IsG && read("StypeU") !== "1"}
      className=""
      expanded={expanded === row.Id}
      onChange={() => onChange(row.Id)}
    >
      <AccordionSummary expandIcon={<ExpandMore />} className="bg-action">
        <div className="w-100 d-flex flex-row align-items-center g-2">
          <TagFormatter struct={row.Struct} />
          <span className="normalTitle">{row.Name}</span>
        </div>
        <div>
          <MuiIconButton
            icon={<Icons.Trash3 size={17} />}
            className="danger-fill"
            onClick={onShowAlert}
            disabled={read("typeColorRules").accessDelete === false}
          />
          <AlertDialog
            showAlert={showAlert}
            type="alertError"
            onClose={onShowAlert}
            onClickOk={onDelete}
            okTitle={<Translator id="ble_pak_shavad" />}
            cancelTitle={<Translator id="enseraf" />}
            questionText={<Translator id="aya_az_hazf_an_etminan_darid" />}
            relationText={<Translator id="relationAlert" />}
            relationData={deleteRelationData}
            loading={loading}
          />
        </div>
      </AccordionSummary>
      <AccordionDetails className="px-2">
        <form className="w-100">
          <Grid container spacing={2} className="mb-4 mb-sm-0">
            <Grid item sm={4} xs={12}>
              <Input
                setValue={setValue.bind(this)}
                name="nameColor"
                validation={controls.nameColor.validation}
                value={controls.nameColor.value}
                label={<Translator id="nameColor" />}
                type="text"
                checkValid={checkValid && !formValid.nameColor}
              />
            </Grid>
            <Grid item sm={4} xs={12} className="mb-4 mb-md-0">
              <MuiColorAutoComplete
                loading={loading}
                options={controls.color.selectItems}
                label={<Translator id={"color"} />}
                value={controls.color.value}
                helperText={checkValid && !formValid.color}
                onChange={(e, value) =>
                  autoCompleteColorHandler(e, value, "color")
                }
              />
            </Grid>
            <Grid
              item
              sm={4}
              xs={12}
              className="d-flex flex-row align-items-center"
            >
              <MuiButton
                loading={loading}
                color="primary"
                title={<Translator id="ezafe_be_list" />}
                onClick={onAddColor}
                fullwidthOnSm
                disabled={read("typeColorRules").accessRegister === false}
              />
            </Grid>
          </Grid>
          <ColorTable data={row.ListColor} />
        </form>
      </AccordionDetails>
    </Accordion>
  );
}

export default ExpandType;
